export const languageStyleMap = {
  'zh':{
    '--dialog-contian-margin-left':'initial',
  },
  'en':{
    '--dialog-label-width':'auto',
    '--dialog-label-text-align':'left',
    '--dialog-contian-margin-left':'0px',
    '--preview_item_label':'138px',
    '--form-item__label':'150px'
  },
}